// Lib Imports
import React from 'react';
import { Box, Heading, Image } from 'grommet';
import { useHistory } from 'react-router-dom';
import { LinkPrevious } from 'grommet-icons';

// Application Imports
import Activated from 'assets/Activated.svg';
const RequestSuccess = () => {
  const history = useHistory();
  return /*#__PURE__*/React.createElement(Box, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    margin: {
      top: 'medium',
      bottom: 'xlarge'
    }
  }, /*#__PURE__*/React.createElement(Image, {
    src: Activated
  })), /*#__PURE__*/React.createElement(Heading, {
    level: 3,
    margin: "none"
  }, "Password reset request success!"), /*#__PURE__*/React.createElement(Heading, {
    level: 5,
    color: "dark-2"
  }, "Your password reset link has been sent successfully!"), /*#__PURE__*/React.createElement(Heading, {
    level: 6
  }, /*#__PURE__*/React.createElement(Box, {
    focusIndicator: false,
    onClick: () => history.push('/login'),
    direction: "row",
    gap: "small",
    style: {
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(LinkPrevious, {
    size: "small"
  }), " Back to Login")));
};
export default RequestSuccess;